import { render } from "./SentimentBarChart.vue?vue&type=template&id=81adbfca"
import script from "./SentimentBarChart.vue?vue&type=script&lang=js"
export * from "./SentimentBarChart.vue?vue&type=script&lang=js"

import "./SentimentBarChart.vue?vue&type=style&index=0&id=81adbfca&lang=css"

import exportComponent from "/Users/noursafadi/Documents/Uni/Parsons-Spring-25/MajorStudio02/MSDV-thesis-2025/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__